import { Icon } from './_Icon';
export const CheckIcon = (props) => <Icon {...props} d="M20 6L9 17l-5-5" />;
